module.exports = __webpack_public_path__ + "static/partner_ingv-7ce2dd7046d76f9545462e48f7e91be6.svg";